// One row on a phone, in a sheet from the bottom of the screen: its state as large
// one-tap buttons, then its name, its columns and its note, each typed where it stands.
// Choosing a state closes the sheet — that is the update made most often.
import he from '../../i18n/he';
import ListCell from './ListCell';
import { columnValues, groupingOf } from './listGroups';
import { StateOptions } from './StateControl';
import { RowDelete } from './ListTable';

const L = he.lists;

export default function ItemSheet({ list, item, onItem, onRemove, onClose }) {
  const grouping = groupingOf(list);
  return (
    <div className="list-sheet-overlay" onClick={onClose} role="presentation">
      <div className="list-sheet" role="dialog" aria-label={item.name} onClick={(e) => e.stopPropagation()}>
        <span className="list-sheet-grab" aria-hidden="true" />
        <div className="list-sheet-head">
          <ListCell className="list-sheet-name" value={item.name} label={L.name} onSave={(name) => name && onItem(item.id, { name })} />
          <RowDelete onRemove={() => { onRemove(item.id); onClose(); }} />
        </div>
        <div className="list-sheet-states" role="menu">
          <StateOptions
            states={list.states}
            current={item.state_id}
            className="list-sheet-option"
            onPick={(id) => { if (id !== item.state_id) onItem(item.id, { state_id: id }); onClose(); }}
          />
        </div>
        {list.columns.map((c) => (
          <div key={c.id} className="list-sheet-field">
            <span className="list-sheet-label">{c.label}</span>
            <ListCell value={item.cells[c.id]} kind={c.kind} label={c.label} onSave={(v) => onItem(item.id, { cells: { [c.id]: v } })} suggestions={grouping.column && grouping.column.id === c.id ? columnValues(list.items, c.id) : null} />
          </div>
        ))}
        <div className="list-sheet-field">
          <span className="list-sheet-label">{L.note}</span>
          <ListCell value={item.note} label={L.note} onSave={(note) => onItem(item.id, { note })} />
        </div>
      </div>
    </div>
  );
}
